export default {
	scores: ['Pauvre', 'Acceptable', 'Ok', 'Bon', 'Super !']
	, BasedOn: 'Basé sur'
	, opinionsFrom: 'opinions des médias sociaux'
	, opinions: 'opinions'
	, media: 'Photos et vidéos'
	, ask: 'Demander des avis'
	, facebook: 'Facebook'
	, feelter: 'Insights<br/>sociaux'
	, comment: 'Commentaire'
	, moreInfo: 'Plus d\'informations'
	, back: 'Arrière'
	, insights: 'Insights'
	, clickhere: 'CLIQUEZ ICI'
	, hoverbuttontext: 'CRITIQUES, MENTIONS ET PHOTOS'
	, rating: 'Rating %d Critiques & Commentaires'
	, translate: 'Traduire'
	, readmore: 'Lire la suite'
	, Score_is_made_of: '%d Score is made of'
	, positive: 'Positive'
	, negative: 'Négative'
	, Clear: 'Claire'
	, Mentioned_by: 'Mentioned By'
	, Female: 'Female'
	, Male: 'Male'
	, Popularity: 'Popularity'
	, last_year: 'last year'
	, a_month_ago: 'a month ago'
	, months_ago: '%d months ago'
	, days_ago: '%d days ago'
	, hours_ago: '%d hours ago'
	, minutes_ago: '%d minutes ago'
	, years_ago: '%d years ago'
	, yesterday: 'yesterday'
	, an_hour_ago: 'an hour ago'
	, a_minute_ago: 'a minute ago'
	, just_now: 'just now'
	, load_more: 'Charger plus'
	, attractions: 'Attractions'
	, business: 'Affaires'
	, cleanliness: 'Propreté'
	, couples: 'Des couples'
	, facilities: 'Installations'
	, family: 'Famille'
	, location: 'Emplacement'
	, parking: 'Parking'
	, "public transport": 'Transport public'
	, service: 'Un service'
, value_for_money: 'Rapport qualité-prix'
  ,  sustainability: 'Durabilité'
   , comfort: 'Confort'
   , staff: 'Personnel'
   , reviews: 'Avis'
   , show_all_reviews: 'Afficher tous les avis',
    all: 'Tout'
}


// WEBPACK FOOTER //
// ./src/app/localize/FR.js